// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumbs_root__39K1y","link":"Breadcrumbs_link__ZObAB","currentRoute":"Breadcrumbs_currentRoute__2e81a"};